import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AttantionMiniCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "#ff6565", fillRule: "evenodd", d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-6.4a.6.6 0 0 1-.595-.515c-.04-.283-.102-.685-.175-1.16-.283-1.831-.73-4.734-.73-5.925 0-1.5 3-1.5 3 0 0 .858-.523 4.45-.796 6.32-.045.308-.083.57-.11.765a.6.6 0 0 1-.595.515m-.7 1.9a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0", clipRule: "evenodd" }) }) });
}
const AttantionMiniCustom = forwardRef(_AttantionMiniCustom);
export { AttantionMiniCustom };
